import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  TreatmentCategory,
  TreatmentCategoryCreateRequest,
  TreatmentCategoryCreateResponse,
  TreatmentCategoryDetails,
  TreatmentCategoryUpdateRequest,
  TreatmentCategoryUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';

@Injectable({
  providedIn: 'root'
})
export class TreatmentCategoryService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/treatment-categories/';
  }

  public getTreatmentCategories(): Observable<TreatmentCategory[]> {
    const url = this.endpoint;
    return this.httpClient.get<TreatmentCategory[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<TreatmentCategory> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<TreatmentCategory>(url, request);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public getTreatmentCategoriesById(id: number): Observable<TreatmentCategory> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<TreatmentCategory>(url);
  }

  public getTreatmentCategorieDetails(id: number): Observable<TreatmentCategoryDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<TreatmentCategoryDetails>(url);
  }

  public deleteTreatmentCategory(id: number): Observable<TreatmentCategory> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<TreatmentCategory>(url);
  }

  public createTreatmentCategory(requestBody: TreatmentCategoryCreateRequest): Observable<TreatmentCategoryCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<TreatmentCategoryCreateResponse>(url, requestBody);
  }

  public updateTreatmentCategory(id: number, requestBody: TreatmentCategoryUpdateRequest): Observable<TreatmentCategoryUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<TreatmentCategoryUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
